import { render, staticRenderFns } from "./questionOtherType.vue?vue&type=template&id=3472349a&scoped=true&"
import script from "./questionOtherType.vue?vue&type=script&lang=js&"
export * from "./questionOtherType.vue?vue&type=script&lang=js&"
import style0 from "./questionOtherType.vue?vue&type=style&index=0&id=3472349a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472349a",
  null
  
)

export default component.exports